var map = {
	"./1.jpg": 15543,
	"./2.jpg": 4616,
	"./3.jpg": 48581,
	"./4.jpg": 1246,
	"./bank-1.jpg": 44776,
	"./bank-2.jpg": 13175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2987;